module.exports = __webpack_public_path__ + "static/img/CareerOpportunitiesImg.602b797.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/CareerOpportunitiesImg.png
// module id = CnKJ
// module chunks = 1